import React, { useState, Suspense } from 'react'
import { connect, useDispatch } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import { createStructuredSelector } from 'reselect'
import { selectStaff, selectedStaffData } from 'redux/staff/selectors'
import { selectUser } from 'redux/user/selectors'
import { Input, Table, Form, Spin, Space } from 'antd'
import StaffAction from 'redux/staff/actions'
import Followup from './Followup'

const { Search } = Input

const mapStateToProps = () =>
  createStructuredSelector({
    staff: selectStaff,
    selectedStaff: selectedStaffData,
    user: selectUser
  })

const ViewStaff = ({ infoData, user, staff, intl: { formatMessage } }) => {
  const [page, setPage] = useState(1)
  const dispatch = useDispatch()

  const onSearch = value => {
    dispatch({
      type: StaffAction.SET_STATE,
      payload: { birthdayFollowup: value },
    })
  }

  const locale = {
    emptyText: formatMessage({ id: 'text.custommessage.leadfollowupData' }),
  }

  const columns = [
    {
      title: formatMessage({ id: 'text.serialNo' }),
      key: 's_no',
      render: (text, record, index) => `${(page - 1) * 10 + index + 1}.`,
    },
    {
      title: formatMessage({ id: 'text.StaffName' }),
      key: 'name',
      dataIndex: ['name'],
    },
    {
      title: formatMessage({ id: 'text.role' }),
      key: 'role',
      dataIndex: ['role'],
    },
    {
      title: formatMessage({ id: 'text.emailid' }),
      key: 'emailid',
      dataIndex: ['emailid'],
    },


    {
      title: formatMessage({ id: 'text.birthDayDate' }),
      dataIndex: ['followup_date'],
      key: 'followup_date',
      render: text => moment(text).format('MMM D, YYYY'),
    },
    {
      title: formatMessage({ id: 'text.action' }),
      key: 'action',
      render: record => (
        <Space size="middle">
          <button
            type="button"
            className="btn btn-link btn-min-padding"
            onClick={() => showFollowup(record)}
            disabled={user?.userRole !== 'Super Admin' && user?.userRole !== 'Vice Chairman'}
          >
            ({formatMessage({ id: 'action.SendWishes' })})
          </button>
        </Space>
      ),
    },
  ]

  const showFollowup = value => {
    dispatch({
      type: StaffAction.SHOW_BIRTHDAY_POPUP,
      payload: {
        ...value,
      },
    })
  }

  const hideFollowup = () => {
    dispatch({
      type: StaffAction.HIDE_BIRTHDAY_POPUP,
    })
  }

  const selectedTodayFollowup = infoData

  return (
    <div className="mb-4">
      <div className="row" hidden>
        <div className="col-md-4">
          <Form.Item>
            <Search
              style={{ width: '100%' }}
              placeholder={formatMessage({ id: 'form.user.placeholder.staffName' })}
              size="large"
              onChange={e => onSearch(e.target.value)}
              allowClear
            />
          </Form.Item>
        </div>
      </div>
      <div className="kit__utils__table">
        <Suspense fallback={<Spin />}>
          {selectedTodayFollowup?.length >= 0 ? (
            <Table
              dataSource={selectedTodayFollowup}
              columns={columns}
              locale={locale}
              rowKey="_id"
              pagination={{
                onChange(current) {
                  setPage(current)
                },
              }}
            />
          ) : (
            <Table
              columns={columns}
              locale={locale}
              loading={{
                indicator: (
                  <div>
                    <Spin />
                  </div>
                ),
              }}
            />
          )}
        </Suspense>
      </div>
      <Followup
        visible={staff?.displayBirthdayWishes}
        title={`Birthday Wishes for ${staff?.selectedData?.name} - ${moment(staff?.selectedData?.dob).format('DD MMMM')}`}
        description={formatMessage({ id: 'text.birthDayWished.description' })}
        onCancel={hideFollowup}
        loading={staff?.adding}
      />
    </div>
  )
}

export default connect(mapStateToProps)(injectIntl(ViewStaff))
